import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PermissionDto } from '@services/api'
import { findAllPermissions } from '../thunks/permissionsThunk'

type permissionState = {
  permissions: PermissionDto[]
}

const initialState: permissionState = {
  permissions: [],
}

const permissionSlice = createSlice({
  name: 'permission',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder.addCase(
      findAllPermissions.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.permissions = payload
      },
    ),
})

export default permissionSlice.reducer
